/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import { H1, H3, H4, historyShape, TSS_DARK_BLUE } from 'tss-core-lib-common';
import { NavLink } from 'react-router-dom';
import HelpContent004 from '../components/HelpContent004';

let styles;

const getCustomerContent = ( tvnId, history ) => { // eslint-disable-line
  // always lowercase
  if ( tvnId === '00d' || tvnId === '65a' || tvnId === 'f70' || tvnId === 'f74' || tvnId === 'f80' || tvnId === 'c01' ) {
    return <HelpContent004 />;
  }
  history.push( '/error/404' );
};

const HelpPage = ( { tvnId, history } ) => (
  <div className={ css( styles.container ) }>
    <div>
      <div className={ css( styles.helpHeaderContent ) }>
        <div className={ css( styles.helpHeader ) }>
          <h1 className={ css( H1 ) }>
            <FormattedMessage id="module.public.help.header" />
          </h1>
        </div>
        <div className={ css( styles.helpContent ) }>
          <h3 className={ css( H3 ) }>
            <FormattedMessage id="module.public.help.content" />
          </h3>
        </div>
        <div className={ css( styles.helpContent ) }>
          <h3 className={ css( H3, styles.helpContentDetail ) }>
            <FormattedMessage id="module.public.help.content.detail" />
          </h3>
        </div>
      </div>
      <div className={ css( styles.container ) }>
        { getCustomerContent( tvnId, history ) }
      </div>
      <div className={ css( styles.footerBlock ) }>
        <div className={ css( H4, styles.footerCell, styles.footerText ) }>
          <FormattedMessage
            id="module.public.help.footer.contact.info"
            values={ {
              link: (
                <NavLink to={ `?contact=true&tvnId=${ tvnId }` } className={ css( styles.link ) }>
                    contact page
                </NavLink>
              ),
            } }
          />
        </div>
      </div>
    </div>
  </div>
);
HelpPage.propTypes = {
  tvnId: PropTypes.string.isRequired,
  history: historyShape.isRequired, // eslint-disable-line
};

HelpPage.defaultProps = {};

styles = StyleSheet.create( {
  container: {
    maxWidth: '706px',
    margin: '0 auto 0 auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  helpHeaderContent: {
    marginTop: '2.3rem',
    marginBottom: '2.3rem',
  },
  helpHeader: {
    marginLeft: '0.9rem',
  },
  helpContent: {
    marginLeft: '0.9rem',
  },
  helpContentDetail: {
    color: '#0070c0',
  },

  footerBlock: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  footerCell: {
    flex: '0 1 5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  footerText: {
    margin: '0.9rem 0 2.3rem 0',
    flex: '0 1 53rem',
    fontSize: '1.5rem',
    color: TSS_DARK_BLUE,
  },
  link: {
    textDecoration: 'underline',
  },
} );

export default HelpPage;



// WEBPACK FOOTER //
// ./src/pages/HelpPage.js